import { Box, FloatingButton, List, ListItemV2, Popover } from "@drone-js/core";
import { type FunctionComponent, useState } from "react";
import { useStaticDataAtomValue } from "../../staticDataAtom";

interface Props {
    isMainPhoto: boolean;
    isHover: boolean;
    onMain?: () => void;
    onRemove?: () => void;
    hideMainPhoto: boolean;
}

export const Menu: FunctionComponent<Props> = ({ isMainPhoto, isHover, onMain, onRemove, hideMainPhoto }) => {
    const [menu, setMenu] = useState(false);
    const {
        cmsData: {
            photo: { setAsMainPhoto, deleteThisPhoto },
        },
    } = useStaticDataAtomValue();

    if (menu || isHover)
        return (
            <Box position="absolute" bottom="8px" right="8px" zIndex={3}>
                <Popover
                    content={
                        <List>
                            {!hideMainPhoto && (
                                <ListItemV2
                                    p="12"
                                    title={setAsMainPhoto}
                                    leadingAsset={{
                                        id: "fill.symbol.pin-board",
                                    }}
                                    state={isMainPhoto ? 0 : undefined}
                                    onClick={() => {
                                        onMain();
                                        setMenu(false);
                                    }}
                                    data-element-name="set-main-photo"
                                />
                            )}
                            <ListItemV2
                                p="12"
                                title={deleteThisPhoto}
                                leadingAsset={{
                                    id: "fill.symbol.bin",
                                }}
                                onClick={onRemove}
                                data-element-name="delete-photo"
                            />
                        </List>
                    }
                    hasInteractiveContent={true}
                    pointerPosition="end-above"
                    visible={menu}
                    onVisibilityChange={setMenu}
                >
                    <FloatingButton
                        hierarchy="tertiary"
                        variant="icon"
                        leadingIcon="fill.symbol.more2"
                        size="s"
                        data-element-name="popover-floating-button"
                    />
                </Popover>
            </Box>
        );
    else return null;
};
